import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { connect } from "react-redux";
import MainWrapper from "../wrappers/MainWrapper";
import CircularProgress from '@material-ui/core/CircularProgress';
import { Link } from "react-router-dom";
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import CustomTextField from "../../components/fields/CustomTextField";
import CheckboxGroup from "../../components/fields/CheckboxGroup";
import { reduxForm, Field, reset } from "redux-form";
import validateEmail from "../../utils/validateEmail";
import { checkfilestatus,downloadViirstoday, downloadModistoday ,checkUserRole} from "../../actions";
import Snackbar from '@material-ui/core/Snackbar';
import NotificationSnackBar from '../../utils/NotificationSnackBar';
import PlusCircleIcon from '@material-ui/icons/AddCircle';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import EnhancedTableToolbar from '../../utils/EnhancedTableToolbar';
import UserTable from '../../utils/MainTable/UserTable';
import { userListStyle } from '../../utils/Style';
import HotspotsFileTable from '../../utils/MainTable/HotspotsFileTable'; 

function getModalStyle() {
    return {
        top: `${50}%`,
        left: `${50}%`,
        transform: `translate(-${50}%, -${50}%)`,
    };
}

const required_fields = [
    { name: "description", label: "description" },
    { name: "expiryDay", label: "expiry day" },
    { name: "type", label: "type" },
];

const WAIT_INTERVAL = 1000;

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    loadingHeight: {
        height: "100%",
        position: "fixed",
        top: "0",
        right: "0"
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        width: 350
    },
    button: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 10
    },
    alreadySignIn: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        marginRight: "auto"
    },
    success: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        marginRight: "auto",
        color: "green"
    }
});
class HotspotsFileList extends React.Component {
    

    constructor(props, context) {
        super(props, context);
        this.state = {
            selected: [],
            open: false,
            isSwitchSnackbarOn: false,
            files: [],
            page: 0,
            rowsPerPage: 5,
            offset: 0,
            dateFrom: "",
            dateTo:"",
            status:[], 
            downloadHotspot:null,
            checkhotspot:null,
            loading:false,
            contextChanged:true,
            userRoles:{
                userRoles:[],
                error:null
            },
        }; 
        this.props.checkUserRole();
    }

    componentDidMount(){
        this.props.checkUserRole();
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        today =yyyy + '-' +mm + '-' + dd ;
        this.setState({ loading: false,
            dateFrom: today,
            dateTo:today,
            retrieveCompstatus:[],
        }); 
    } 
    
 
    static getDerivedStateFromProps(props, state) {
        let update = {};
       
        if (props.files  !== state.files) {
            update.files=props.files ;
        } 
        if (props.status  !== state.status) {
            update.status= props.status;
        }   

        update.loading = false;
        if(props.userRoles.success !== null)
        if(!props.userRoles.success){ 
            localStorage.clear(); 
            props.history.push("/signIn"); 
        }
        if(props.userRoles.userRoles.length !== state.userRoles.userRoles.length){ 
            if(props.userRoles.userRoles.length === 0){ 
            localStorage.clear(); 
            props.history.push("/signIn"); 
            }
        }

        return update;
    }
 

    updateSnackbarStatus = (snackbarObject) => {
        this.setState({
            isSnackbarError: snackbarObject.isSnackbarError,
            isSwitchSnackbarOn: snackbarObject.isSwitchSnackbarOn,
            snackbarErrorMessage: snackbarObject.ErrorMessage
        })
    }

    updateSnackbarStatusFalse = () => {
        if (this.state.isSwitchSnackbarOn) {
            this.setState({ isSwitchSnackbarOn: false })
        }
    }
    
    /*
    _handleSubmit = values => {
        this.handleModalClose();
        Object.assign(values, { id: this.state.id }, { keyword: '' }, { offset: this.setNewOffset(this.state.rowsPerPage, this.state.page) }, { limit: this.state.rowsPerPage });
        this.props.registerPackage(values, this.props.history);
    };
    handleModalOpen = (id, username) => {
        this.updateSnackbarStatusFalse();
        this.setState({
            id: id,
            username: username,
            open: true,
        });
    };

    handleModalClose = () => {
        this.setState({ open: false });
        this.props.reset();
    }; 
    handleActive = () => {
        this.updateSnackbarStatusFalse();
        this.props.updateuserstoactive(this.state.selected, this.state.searchVal, this.setNewOffset(this.state.rowsPerPage, this.state.page), this.state.rowsPerPage);
    };

    handleInactive = () => {
        this.updateSnackbarStatusFalse();
        this.props.updateuserstoinactive(this.state.selected, this.state.searchVal, this.setNewOffset(this.state.rowsPerPage, this.state.page), this.state.rowsPerPage );
    };

    handleSelectAllClick = (event, checked) => {
        this.updateSnackbarStatusFalse();
        if (checked) {
            this.setState({ selected: this.state.users.map(n => n.id) });
            return;
        }
        this.setState({ selected: [] });
    };

    handleClick = (event, id) => {
        this.updateSnackbarStatusFalse();
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        this.setState({ selected: newSelected });
    };

    handleChangePage = (event, page) => {
        this.updateSnackbarStatusFalse();
        this.props.fetchUser(this.state.searchVal,this.setNewOffset(this.state.rowsPerPage, page), this.state.rowsPerPage);
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.updateSnackbarStatusFalse();
        this.props.fetchUser(this.state.searchVal,this.setNewOffset(event.target.value, this.state.page), event.target.value);
        this.setState({ rowsPerPage: event.target.value });
    };

    setNewOffset = (rowPerPage, page) => {
        return rowPerPage * page;
    }
*/
    handleSearch = event => {
        if(this.state.contextChanged){
        this.setState({ loading: true }); 
        this.updateSnackbarStatusFalse();   
       // this.setState({ searchVal: event.target.value })
       this.props.checkfilestatus(this.state.dateFrom, this.state.dateTo);
        }
    };

    handleDate = (name)  => event =>{
        let that = this;
        let e =event;
        console.log( this.state[name])
        if(e.target.value !== this.state[name]){
        that.setState({[name]: e.target.value,
            contextChanged:true});
        }
      /*  clearTimeout(this.timer);
        this.timer = setTimeout(function () {
            
           
         
        }, WAIT_INTERVAL);
        */ 
    }

    handleDownloadMODISToday=()=>{
        this.setState({ loading: true }); 
        console.log("modis")
        this.props.downloadModistoday(); 
    }

    handleDownloadVIIRSToday=()=>{
        this.setState({ loading: true }); 
        console.log("viirs")
        this.props.downloadViirstoday();
    }


    render() {
        if (this.state.loading) {
            return (
                <div className="d-flex justify-content-center">
                    <CircularProgress color="primary" size={70} thickness={7} />
                </div>
            );
        }

        const { classes } = this.props;
        const { users, order, orderBy, selected, rowsPerPage, page, offset, isSwitchSnackbarOn, isSnackbarError } = this.state;
      
        return (
            <MainWrapper
            history={this.props.history}
                isDisplayOn="none"
                userRoles={this.props.userRoles}>
          
                <Paper className={classes.root}>
                    <EnhancedTableToolbar
                        tableName='Hotspots' 
                        numSelected={0}
                    />
                    <div className={classes.search}>
                        <Grid container spacing={8} alignItems="flex-end">
                            <Grid item>
                                <SearchIcon />
                            </Grid>
                            <Grid item>
                            <TextField
                                id="dateFrom"
                                label="Date From"
                                type="date"
                                defaultValue={this.state.dateFrom}
                                InputLabelProps={{
                                shrink: true,
                                }} 
                                onChange={this.handleDate('dateFrom')}
                            />
                            </Grid>
                            <Grid item>
                            <TextField
                                id="dateTo"
                                label="Date To"
                                type="date"
                                defaultValue={this.state.dateTo} 
                                InputLabelProps={{
                                shrink: true,
                                }}
                                onChange={ this.handleDate('dateTo')}
                            />
                            </Grid>
                            <Grid item>
                                <Button  variant="outlined"
                                onClick={(e) => this.handleSearch(e) } >Search</Button>
                            </Grid>
                            
                        </Grid>
                    </div>
                    <div className={classes.tableWrapper}>
                        <HotspotsFileTable 
                            data={this.state.files} 
                        />
                    </div>
                    <div className={classes.search}>
                        <Button onClick={this.handleDownloadMODISToday.bind(this)}  color="primary" variant="contained">Download Today's MODIS Hotspot</Button><br/><br/>
                        
                        <Button onClick={this.handleDownloadVIIRSToday.bind(this)}   color="primary" variant="contained">Download Today's VIIRS Hotspot</Button>
                    </div>
                    <NotificationSnackBar
                            isSwitchSnackbarOn={this.state.isSwitchSnackbarOn}
                            isSnackbarError={this.state.isSnackbarError}
                            snackbarErrorMessage={this.state.snackbarErrorMessage}
                    />
                </Paper> 
                {this.state.loading ? (
                <Grid container className={classes.root}>
                    <Grid item xs={12}>
                        <Grid container className={classes.loadingHeight} justify='center' alignItems='center'>
                            <CircularProgress color="primary" size={70} thickness={7} />
                        </Grid>
                    </Grid>
                </Grid>
            ) : null
            }
            </MainWrapper>
        );
    }
}

HotspotsFileList.propTypes = {
    classes: PropTypes.object.isRequired,
};

function validate(values) {
    const errors = {};

    
    return errors;
}

let SignInWithStyles = withStyles(styles)(HotspotsFileList);

SignInWithStyles = reduxForm({ 
    form: "hotspotfilesform"
})(SignInWithStyles);


  //    getNotExpiredPackages={this.props.notexpiredpackagesResult}>

const mapStateToProps = ({ userRoles,checkhotspot,downloadHotspot }) => { 
    return {
        userRoles: userRoles,
        files: checkhotspot.files,
        status: downloadHotspot.status,
        downloadHotspot: downloadHotspot,
        checkhotspot: checkhotspot
    };
};

export default connect(
    mapStateToProps,
    { checkfilestatus,downloadViirstoday, downloadModistoday,checkUserRole }
)(SignInWithStyles);




// WEBPACK FOOTER //
// ./src/components/tabs/HotspotsFileList.js